/**
 * Created by neo on 18.12.20.
 */
import { makeAutoObservable } from 'mobx';

export type MeasureEntry = {
  amount: number;
  unitShort: string;
};

export function createMeasureEntry(json?: Partial<MeasureEntry>): MeasureEntry {
  return makeAutoObservable({
    amount: json?.amount ?? 0,
    unitShort: json?.unitShort ?? '',
  });
}
